"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    direction = _useContext.direction,
    themeColors = _useContext.themeColors;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView,
    viewHeight = _useDeviceData.viewHeight;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    setStartDirection = _useStylesUtils.setStartDirection;
  var ccEnvironmentManagStyle = (0, _react.useMemo)(function () {
    var ccEnvironmentManager = (0, _css.css)({
      direction: direction
    });
    var ccEnvironmentManagerContainer = (0, _css.css)({
      maxHeight: isMobileView ? '100%' : "calc(".concat(viewHeight + 'px', " - ").concat(pxToRem(62), ")"),
      height: isMobileView ? '100%' : "calc(".concat(viewHeight + 'px', " - ").concat(pxToRem(62), ")"),
      display: 'flex',
      flexDirection: 'column'
    });
    var ccEnvironmentManagerRow = (0, _css.css)({
      padding: "".concat(pxToRem(16), " 0")
    });
    var ccEnvironmentManagerCellLabel = (0, _css.css)({
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      lineHeight: 1.4,
      marginBottom: pxToRem(4),
      padding: "0 ".concat(pxToRem(14)),
      fontWeight: 'bold',
      fontSize: pxToRem(isMobileView ? 16 : 14)
    });
    var ccEnvironmentManagerCellContent = (0, _css.css)({
      position: 'relative',
      maxWidth: '100%'
    });
    var ccEnvironmentManagerWarning = (0, _css.css)(_objectSpread({
      position: 'absolute',
      fontSize: pxToRem(14),
      color: 'red',
      bottom: pxToRem(-20)
    }, setStartDirection(5)));
    var ccEnvironmentManagerError = (0, _css.css)({
      color: 'red',
      padding: "0 ".concat(pxToRem(8))
    });
    var ccEnvironmentManagerAudiencePickerContainer = (0, _css.css)({
      padding: "".concat(pxToRem(14), " 0"),
      display: 'flex',
      flexFlow: 'column',
      overflow: 'hidden',
      minHeight: pxToRem(240)
    });
    var ccEnvironmentManagerAudiencePicker = (0, _css.css)({
      flex: 'auto',
      overflowX: 'hidden',
      overflowY: 'auto'
    });
    var ccEnvironmentManagerDates = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      gap: pxToRem(5)
    });
    return {
      ccEnvironmentManager: ccEnvironmentManager,
      ccEnvironmentManagerContainer: ccEnvironmentManagerContainer,
      ccEnvironmentManagerRow: ccEnvironmentManagerRow,
      ccEnvironmentManagerCellLabel: ccEnvironmentManagerCellLabel,
      ccEnvironmentManagerCellContent: ccEnvironmentManagerCellContent,
      ccEnvironmentManagerWarning: ccEnvironmentManagerWarning,
      ccEnvironmentManagerError: ccEnvironmentManagerError,
      ccEnvironmentManagerAudiencePickerContainer: ccEnvironmentManagerAudiencePickerContainer,
      ccEnvironmentManagerAudiencePicker: ccEnvironmentManagerAudiencePicker,
      ccEnvironmentManagerDates: ccEnvironmentManagerDates
    };
  }, [direction, isMobileView, viewHeight, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, pxToRem, setStartDirection]);
  return {
    'cc-EnvironmentManager': ccEnvironmentManagStyle.ccEnvironmentManager,
    'cc-EnvironmentManagerContainer': ccEnvironmentManagStyle.ccEnvironmentManagerContainer,
    'cc-EnvironmentManager_Row': ccEnvironmentManagStyle.ccEnvironmentManagerRow,
    'cc-EnvironmentManager_Cell_Label': ccEnvironmentManagStyle.ccEnvironmentManagerCellLabel,
    'cc-EnvironmentManager_Cell_Content': ccEnvironmentManagStyle.ccEnvironmentManagerCellContent,
    'cc-EnvironmentManager_Warning': ccEnvironmentManagStyle.ccEnvironmentManagerWarning,
    'cc-EnvironmentManager_Error': ccEnvironmentManagStyle.ccEnvironmentManagerError,
    'cc-EnvironmentManager_AudiencePickerContainer': ccEnvironmentManagStyle.ccEnvironmentManagerAudiencePickerContainer,
    'cc-EnvironmentManager_AudiencePicker': ccEnvironmentManagStyle.ccEnvironmentManagerAudiencePicker,
    'cc-EnvironmentManager_Dates': ccEnvironmentManagStyle.ccEnvironmentManagerDates
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;